export default __webpack_public_path__ + "static/media/iconFavoritado.565c223f.svg";